import React, { Component } from 'react';
import { Navigate } from 'react-router-dom'
import { getCurrentUser } from '../util/AuthUtils';

class OAuth2RedirectHandler extends Component {
    getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');

        var results = regex.exec(this.props.location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    componentDidMount() {
        const error = this.getUrlParameter('error');
        if (error) return;

        // Cookie is already set by the backend before the redirect — just fetch user data
        getCurrentUser()
            .then(usr => {
                if (usr.companies && usr.companies.length == 1) {
                    localStorage.setItem("company", JSON.stringify(usr.companies[0]))
                }
                localStorage.setItem("user", JSON.stringify(usr.user))
                window.location.reload();
            }).catch(error => {
                this.setState({ loading: false });
            });
    }

    render() {
        const error = this.getUrlParameter('error');
        if (!error) {
            return <Navigate to={{
                pathname: "/home",
                state: { from: this.props.location, authenticated: true }
            }} />;
        } else {
            return <Navigate to={{
                pathname: "/login",
                state: {
                    from: this.props.location,
                    error: error
                }
            }} />;
        }
    }
}

export default OAuth2RedirectHandler;